import { useQuery, type Query } from '@tanstack/react-query';
import type { ApplicationsContract } from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { terraApiWrapper } from '../../utils/terraApiWrapper';

export const DYNAMIC_APPLICATION_SCAN_AUTOMATION_QUERY_KEY =
  'dynamic-application-scan-automation';

const fetchDynamicApplicationScanAutomation = async ({
  applicationId,
}: {
  applicationId: string;
}) => {
  return terraApiWrapper<
    typeof ApplicationsContract.getDynamicApplicationScanAutomation
  >({
    endpointFn: () =>
      applicationsClient.getDynamicApplicationScanAutomation({
        params: { id: applicationId },
      }),
  });
};

type AutomationState = Awaited<
  ReturnType<typeof fetchDynamicApplicationScanAutomation>
>;

export const useDynamicApplicationScanAutomation = ({
  applicationId,
  enabled = true,
  refetchInterval,
}: {
  applicationId: string;
  enabled?: boolean;
  refetchInterval?:
    | number
    | false
    | ((query: Query<AutomationState>) => number | false);
}) => {
  return useQuery({
    queryKey: [DYNAMIC_APPLICATION_SCAN_AUTOMATION_QUERY_KEY, applicationId],
    queryFn: () => fetchDynamicApplicationScanAutomation({ applicationId }),
    enabled: enabled && Boolean(applicationId),
    refetchInterval,
  });
};
